export const aboutData = {
  title: "Who I am",
  description1: "Hello, my name is Hager Khaled .from Alexandria, Egypt.",
  description2:
    "As a professional programmer, I am passionate about exploring new technologies and love to learn. I have a self-learning attitude and can quickly adapt to new challenges. I'm particularly fond of open-source technologies and enjoy working with different software engineering stacks.",
  description4:
    "When I'm not programming, I like to unwind by playing board games. In fact, I enjoy creating my own board games as well! I'm also a big movie buff and enjoy watching films in my free time. Lastly, reading is another hobby of mine, and I love to delve into different genres and authors.",
};
